import {BifrostBackendApi, BifrostBackendNestApi} from "../gateways/BifrostBackendApi.js";
import { store } from "../store";

const ProductProvider = {
	async getProducts({productIds}) {
		const res = await BifrostBackendNestApi.post(`/intusr/products`, {
			filterBy: {
				productIds
			}
		},
		{
			headers: {
				Authorizationidp: store.getters.applicationUserIdpToken
			}
		});
		return res.data;
	},

	findProductStatistics() {
		return BifrostBackendApi.get("/product-statistics", {
			headers: { Authorization: store.getters.jwtToken }
		});
	},

	async getEarliestPickupDate({productId, fromDate, shopId, tenantId}) {
		const queryParams = {
			tenantId,
			fromDate: fromDate.toISOString()
		};

		if (shopId) {
			queryParams.shopId = shopId;
		}

		const res = await BifrostBackendApi.get(`/product/earliest-pickup-date/${productId}`, {
			params: queryParams
		});

		return new Date(res.data);
	}
};

export default Object.freeze(ProductProvider);
